<template>
  <div>
    <v-alert
        v-for="banner in filteredBanners"
        :key="banner.id"
        color="info"
        dark
        dismissible
        class="mb-4"
        @input="handleClose(banner.id)"
    >
      <div class="d-flex align-start">
        <div class="banner-content">
          <span class="content-text">{{ getLocalizedContent( banner ) }}</span>
        </div>
      </div>
    </v-alert>
  </div>
</template>


<script>
export default {
    name : 'BannerAlert',
    props : {
        isAdmin : Boolean,
        isSubAdmin : Boolean
    },
    data()
    {
        return {
            banners: [],
            hiddenBanners: []
        }
    },
    computed : {
        filteredBanners()
        {
            try
            {
                return this.banners.filter( b =>
                !this.hiddenBanners.includes( b.id ) && this.hasValidContent( b ) && this.checkDisplayTarget( b )
                ).sort( ( a, b ) => new Date( b.createdAt ) - new Date( a.createdAt ) );
            }
            catch( e )
            {
                return [];
            }
        }
    },
    methods : {
        /**
         * Persist display once strategy and emit close event.
         */
        handleClose( bannerId )
        {
            const banner = this.banners.find( b => b.id === bannerId );
            if( banner?.displayStrategy === 'once' )
            {
                const closedOnce = JSON.parse( localStorage.getItem( 'closedBannersOnce' ) || '[]' );
                if( !closedOnce.includes( bannerId ) )
                {
                    closedOnce.push( bannerId );
                    localStorage.setItem( 'closedBannersOnce', JSON.stringify( closedOnce ) );
                }
            }
            this.$emit( 'close-banner', bannerId );
        },
        /**
         * Verifie banner has displayable content in available localizations.
         */
        hasValidContent( banner )
        {
            return !!this.getLocalizedContent( banner );
        },
        /**
         * Retrieve localized content prioritizing current language then default language.
         */
        getLocalizedContent( banner )
        {
            if( !banner?.selectedBanners?.length )
            {
                return '';
            }
            const currentLocale = this.$i18n.locale.toUpperCase();
            const availableLangs = banner.selectedBanners;
            const currentLangContent = availableLangs.find( b => b.language.toUpperCase() === currentLocale );
            if( currentLangContent?.bannerContent )
            {
                return currentLangContent.bannerContent;
            }
            const defaultLangContent = availableLangs.find( b => b.isDefault );
            if( defaultLangContent?.bannerContent )
            {
                return defaultLangContent.bannerContent;
            }
            return '';
        },
        /**
         *  Determine banner visibility based on user role and display targets.
         */
        checkDisplayTarget( banner )
        {
            const displayTargets = banner.displayTarget || [];
            const hasAccessUser = displayTargets.includes( 'AccessUser' );
            const isAdminTarget = this.isAdmin && displayTargets.includes( 'Admin' );
            const isSubAdminTarget = this.isSubAdmin && displayTargets.includes( 'SubAdmin' );
            return hasAccessUser || isAdminTarget || isSubAdminTarget;
        }
    },
    mounted()
    {
        const rawBanners = window.$cc_user_info.banners || [];
        this.banners = rawBanners.map( banner => ( {
            ...banner,
            displayStrategy : banner.displayStrategy || 'always'
        } ) );
    }
}
</script>

<style scoped>
  .banner-content {
    width: calc(100% - 42px);
    text-align: left;
    word-break: break-word;
}

  @media (max-width: 600px) {
    .banner-content {
        width: 100%;
        padding-right: 24px;
        font-size: 0.9rem;
    }
    .mobile-alert-margin {
        margin-bottom: 10px !important;
    }
}
</style>